module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/AT-SPG-prem.43902b2c.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/AT-SPG-prem.png
// module id = 2710
// module chunks = 11